import type { ActivityIcon } from '@hbac/contract';
import {
  BarChart3, BookOpen, Braces, CalendarDays, Handshake, Lightbulb, Presentation, Rocket, Trophy, Users,
  type LucideIcon,
} from 'lucide-react';
import { usePublicSiteContent } from '../../services/public-queries';
import { Skeleton } from '../components/Skeleton';
import { revealDelay } from '../components/motion';

/** Every icon an editor may pick, by the key stored in site_content. */
export const ACTIVITY_ICON_COMPONENTS: Record<ActivityIcon, LucideIcon> = {
  presentation: Presentation,
  trophy: Trophy,
  code: Braces,
  users: Users,
  book: BookOpen,
  lightbulb: Lightbulb,
  chart: BarChart3,
  handshake: Handshake,
  calendar: CalendarDays,
  rocket: Rocket,
};

export function Activities() {
  const { content } = usePublicSiteContent();
  return (
    <section id="activities" className="scroll-mt-20 bg-slate-50 py-16 md:py-24 dark:bg-navy-950">
      <div className="mx-auto w-full max-w-[1328px] px-4 md:px-6">
        <p className="text-[13px] font-bold uppercase tracking-[0.2em] text-brand-700 dark:text-brand-400">Hoạt động</p>
        <h2 className="mt-2 text-3xl font-extrabold tracking-tight text-slate-900 md:text-4xl lg:text-[42px] lg:leading-[1.15] dark:text-white">
          CLB làm gì?
        </h2>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {content
            ? content.activities.items.map((a, i) => {
                const Icon = ACTIVITY_ICON_COMPONENTS[a.icon] ?? Presentation;
                return (
                  <div
                    key={i}
                    data-reveal
                    style={revealDelay(i)}
                    className="rounded-2xl border border-slate-100 bg-white p-6 shadow-sm transition-shadow hover:shadow-md dark:border-navy-700 dark:bg-navy-800"
                  >
                    <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-50 text-brand-700 dark:bg-brand-500/15 dark:text-brand-400">
                      <Icon size={20} />
                    </div>
                    <h3 className="mt-4 text-base font-bold text-slate-800 dark:text-slate-100">{a.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-slate-500 dark:text-slate-400">{a.body}</p>
                  </div>
                );
              })
            : [0, 1, 2, 3].map((i) => <Skeleton key={i} className="h-48" />)}
        </div>
      </div>
    </section>
  );
}
